
import React from 'react';

export default function ContactInfo() {
  const contactCards = [
    {
      icon: 'ri-map-pin-2-line',
      color: '#038C7F',
      title: 'Visit Our Office',
      lines: ['Block B&C 3rd Floor, Ntinda Shopping Complex', 'Plot 31 Ntinda - Kisaasi Rd, Kampala'],
      action: {
        label: 'Get Directions',
        href: 'https://www.google.com/maps/place/Asili+Visuals/@0.3527179,32.6124598,17z',
        icon: 'ri-route-line',
      },
    },
    {
      icon: 'ri-mail-send-line',
      color: '#F2780C',
      title: 'Email Us',
      lines: ['info@asili.co.ug', 'okuti@asili.co.ug'],
      action: {
        label: 'Send Email',
        href: 'mailto:info@asili.co.ug',
        icon: 'ri-mail-line',
      },
    },
    {
      icon: 'ri-phone-line',
      color: '#038C7F',
      title: 'Call Us',
      lines: ['0761 375736', 'Mon – Fri: 9AM – 6PM EAT'],
      action: {
        label: 'Call Now',
        href: 'tel:+256761375736',
        icon: 'ri-phone-line',
      },
    },
    {
      icon: 'ri-whatsapp-line',
      color: '#25D366',
      title: 'WhatsApp',
      lines: ['Quick responses', 'Available during business hours'],
      action: {
        label: 'Chat on WhatsApp',
        href: 'https://wa.me/256761375736',
        icon: 'ri-whatsapp-line',
      },
    },
  ];

  // Helper to safely build external links
  const getLinkProps = (href) => {
    const isExternal = typeof href === 'string' && href.startsWith('http');
    return {
      target: isExternal ? '_blank' : undefined,
      rel: isExternal ? 'noopener noreferrer nofollow' : undefined,
    };
  };

  return (
    <section className="py-16 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-[#038C7F]/10 rounded-full mb-4">
            <i className="ri-contacts-book-2-line text-[#038C7F] text-xs"></i>
            <span className="text-[10px] font-bold text-[#038C7F] uppercase tracking-wider">
              Reach Us
            </span>
          </div>
          <h2 className="text-2xl sm:text-3xl font-bold text-[#0D0D0D] mb-3">
            Multiple Ways to{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#038C7F] to-[#F2780C]">
              Connect
            </span>
          </h2>
          <p className="text-sm text-gray-500 max-w-md mx-auto">
            Choose the most convenient way to reach our team. We&apos;re always happy to hear from
            you.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5">
          {contactCards.map((card, idx) => (
            <div
              key={idx}
              className="group relative bg-white border border-gray-100 rounded-xl p-5 sm:p-6 hover:shadow-lg hover:border-gray-200 transition-all duration-300"
            >
              <div
                className="w-11 h-11 rounded-xl flex items-center justify-center mb-4 transition-transform duration-300 group-hover:scale-110"
                style={{ backgroundColor: `${card.color}15` }}
              >
                <i className={`${card.icon} text-xl`} style={{ color: card.color }}></i>
              </div>
              <h4 className="text-sm font-bold text-[#0D0D0D] mb-2">{card.title}</h4>
              {card.lines.map((line, i) => (
                <p key={i} className="text-xs text-gray-500 leading-relaxed">
                  {line}
                </p>
              ))}
              <a
                href={card.action?.href || '#'}
                {...getLinkProps(card.action?.href)}
                className="mt-4 inline-flex items-center gap-1.5 text-xs font-semibold transition-colors cursor-pointer"
                style={{ color: card.color }}
              >
                <i className={`${card.action?.icon} text-sm`}></i>
                <span>{card.action?.label}</span>
                <i className="ri-arrow-right-up-line text-sm group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
